import {
  Box,
  Button,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import apiHelper from "../../../util/ApiHelper";
import ImageUpload from "../../ImageUpload";
import FooterColumnSections from "./FooterColumnSections";
import FooterSocialNetworkSection from "./FooterSocialNetworkSection";
import { useLoading } from "../../../util/LoadingProvider";

const frontendUrl = process.env.REACT_APP_CINEFAN_WEB_HOSTNAME;

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    "& span": {
      fontWeight: "bold",
      fontSize: "13px",
    },
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    position: "relative",
    "& img": {
      width: "100%",
      height: "auto",
    },
    "& button": {
      position: "absolute",
      top: "-10px",
      right: "-10px",
      zIndex: "10",
      display: "block",
      color: "rgba(48, 111, 157, 0.8)",
      background: "white",
      padding: 0,
      transition: "200ms all ease-out",
      "&:hover": {
        color: "rgba(48, 111, 157, 1)",
        background: "white",
      },
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

const defaultOptionsValue = {
  header: {},
  footerColumns: [],
  social: [],
};

function OptionPage({ disabled, ...props }) {
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);
  const [defaultValues, setDefaultValues] = React.useState(defaultOptionsValue);
  const { setLoading } = useLoading();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const getOptions = async () => {
    setLoading(true);
    try {
      const result = await apiHelper.cinefan.getOptions();
      console.log(result.data);
      setDefaultValues(result.data);
      setActiveTab(0);
      reset(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const updateOptions = async (value) => {
    setLoading(true);
    try {
      const result = await apiHelper.cinefan.updateOptions(value);
      console.log(result.data);
      if (value.status === "PREVIEW" && result.data.id) {
        window.open(
          frontendUrl + "/preview/option/" + result.data.id,
          "_blank"
        );
      }

      if (result.data.id) {
        toast.dark("Your changes is saved.");
        await getOptions();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (status) => (value) => {
    updateOptions({ ...value, status });
  };

  React.useEffect(() => {
    getOptions();
  }, []);

  React.useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Options
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab
          label="English"
          {...a11yProps(0)}
        />
        <Tab
          label="繁體中文"
          {...a11yProps(1)}
        />
      </Tabs>
      <form>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            <Box className={classes.innerBox} style={{ marginBottom: 0 }}>
              <Grid container direction="column" spacing={3}>
                <Grid container item xs={6} spacing={2}>
                  <Grid item xs={12}>
                    <span>Header Brand Logo</span>
                  </Grid>
                  <Grid item xs={12}>
                    <ImageUpload
                      control={control}
                      name="header.localizations.en.brandLogo"
                      label="Change Remark Image"
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={6}>
                  <span>Header Subscription URL</span>
                  <Controller
                    name="header.localizations.en.subscriptionUrl"
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <TextField
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "User will be directed to the URL when clicking the “Subscribe” button of header"
                          }
                        />
                      );
                    }}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <span>Footer Acknowledgements Columns</span>
                  <FooterColumnSections
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    activeLang={activeTab === 0 ? 'en':"tc"}
                    disabled={disabled}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <span>Footer Social Networks</span>
                  <FooterSocialNetworkSection
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    activeLang="en"
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Box className={classes.innerBox} style={{ marginBottom: 0 }}>
              <Grid container direction="column" spacing={3}>
                <Grid container item xs={6} spacing={2}>
                  <Grid item xs={12}>
                    <span>Header Brand Logo</span>
                  </Grid>
                  <Grid item xs={12}>
                    <ImageUpload
                      control={control}
                      name="header.localizations.tc.brandLogo"
                      label="Change Remark Image"
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={6}>
                  <span>Header Subscription URL</span>
                  <Controller
                    name="header.localizations.tc.subscriptionUrl"
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <TextField
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "User will be directed to the URL when clicking the “Subscribe” button of header"
                          }
                        />
                      );
                    }}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <span>Footer Acknowledgements Columns</span>
                  <FooterColumnSections
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    activeLang={activeTab === 0 ? 'en':"tc"}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <span>Footer Social Networks</span>
                  <FooterSocialNetworkSection
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    activeLang="tc"
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="button"
                style={{ marginRight: "0px", padding: "9px 16px" }}
                onClick={handleSubmit(onSubmit("PREVIEW"))}
              >
                Preview
              </Button>

              <Button
                type="button"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
                onClick={handleSubmit(onSubmit("PUBLISHED"))}
              >
                Save
              </Button>
            </div>
          )}
        </fieldset>
      </form>
    </>
  );
}

export default OptionPage;
